import React, { useState } from 'react';
import classNames from 'classnames';
import EmailIcon from '@/images/icons/EmailIcon';
import VerificationCode from '@/components/VerificationCode';
import ModalAction from '@/components/ModalAction';
import LoaderIcon from '@/images/icons/Loader';
import { Input } from '@/components/Form/Input';

interface ForceEmailConfirmModalProps {
	modalOpen: boolean;
	setModalOpen: (open: boolean) => void;
	email: string;
	setEmail: (value: string) => void;
	emailConfirmCode: string;
	setEmailConfirmCode: (code: string) => void;
	resendTimer: number;
	onResend: () => void;
	onSend: () => void;
	onVerify: () => void;
	hasResendBeenClicked: boolean;
	isLoading: boolean;
	requestId?: string | null;
}

const ForceEmailConfirmModal = ({
	modalOpen,
	setModalOpen,
	email,
	setEmail,
	emailConfirmCode,
	setEmailConfirmCode,
	resendTimer,
	onResend,
	onSend,
	onVerify,
	hasResendBeenClicked,
	isLoading,
	requestId,
}: ForceEmailConfirmModalProps) => {
	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if ((requestId && (emailConfirmCode.length < 6 || isLoading)) || isLoading) return;

		if (requestId) {
			onVerify();
		} else {
			onSend();
		}
	}

	return (
		<ModalAction
			id="email-confirm-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			size={undefined}
			hideClose={true}
		>
			<form onSubmit={onSubmit}>
				<EmailIcon className="w-14 h-14 rounded-full mb-6" />
				<h2 className="h2 mb-4 leading-[0.9]">
					Confirm your email
				</h2>
				{!requestId ? (
					<>
						<div className="mb-6">Please confirm your email address to proceed</div>
						<div className="w-full mb-6">
							<Input
								className="h-12"
								type="email"
								name="email-to-verify"
								placeholder="Email"
								onChange={(e) => setEmail(e.target.value)}
								value={email}
								required
							/>
						</div>
					</>
				) : (
					<>
						<div className="flex flex-wrap gap-2 mb-6">
							<div>Enter the code sent to your email {email}</div>
							<button
								type="button"
								className={classNames(
									'text-[#3CBBCE] hover:no-underline focus:outline-none',
									hasResendBeenClicked && resendTimer > 0
										? 'opacity-50 cursor-not-allowed'
										: 'underline'
								)}
								onClick={onResend}
							>
								Resend
							</button>
							{hasResendBeenClicked && resendTimer > 0 && (
								<div>You can resend the code in {resendTimer}s</div>
							)}
						</div>
						<div className="mb-8">
							<VerificationCode
								length={6}
								onChange={(code: string) => setEmailConfirmCode(code)}
							/>
						</div>
					</>
				)}
				<button
					type="submit"
					className="btn-primary w-full h-10"
				>
					{isLoading ? (
						<div className="flex items-center justify-center py-1 pointer-events-none">
							<LoaderIcon className="animate-rotation w-6 h-6 text-white" />
						</div>
					) : (
						<span>{requestId ? 'Verify' : 'Send code'}</span>
					)}
				</button>
			</form>
		</ModalAction>
	);
}

export default ForceEmailConfirmModal;
